import State from '../core/State';
import { Organization } from '@kaizenplatform/intelligence-entity';
import produce, { Draft } from 'immer';

export const startFetchingOrganizations = () =>
  produce((draft: Draft<State>) => {
    draft.availableOrganizations.fetching = draft.availableOrganizations.fetching + 1;
  });

export const finishFetchingOrganizations = (organizations: Organization[]) =>
  produce((draft: Draft<State>) => {
    draft.availableOrganizations.items = organizations;
    draft.availableOrganizations.fetching = draft.availableOrganizations.fetching - 1;
  });
